import { render, staticRenderFns } from "./VideoDPlayer.vue?vue&type=template&id=3f7125b0"
import script from "./VideoDPlayer.vue?vue&type=script&lang=js"
export * from "./VideoDPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports